/**
 * Version stamped into every saved Puck payload on publish (BR-5406).
 * Bump on breaking changes to the saved data shape so the render side
 * (PuckStep / page templates) can branch on migration.
 */
export const PUCK_DATA_VERSION = '0.0.1'

/** Version assumed for saved data that predates version stamping. */
export const PUCK_DATA_VERSION_FALLBACK = '0.0.0'
